import React from 'react';

import bannerBg from '../../assets/images/agent/bannerBg.jpg'
function AgentBanner() {

  return (
    <>
        <div className="agentPageBanner">
            <img src={bannerBg} alt="" />
            <div className="agentPageBannerDetails">
                <h1>Connect with Top Real Estate Agents</h1>
                <p>Find reliable real estate agents in your area. Connect with experts to buy, sell, or rent properties effortlessly and with confidence.</p>
            </div>
        </div>
    </>
  );
}

export default AgentBanner;
